import * as Types from '../../constants/actionTypes';

export default (state = {}, action) => {
  //console.log(`state in auth is :`,state);
  switch (action.type) {
    case Types.GET_RECEPTION_REPORTS_SUCCESS: {
      return {
        ...state,
        receptionReports: action.payload
      }
    }
    case Types.GET_BOOKING_REPORTS_SUCCESS: {
      return {
        ...state,
        bookingReports: action.payload
      }
    } 
    case Types.GET_VALUEBACK_REPORTS_SUCCESS: {
      return {
        ...state,
        valueBackReports: action.payload
      }
    }
    case Types.GET_REVENUSHARE_REPORTS_SUCCESS: {
      return {
        ...state,
        revenuShareReports: action.payload
      }
    }  
    case Types.GET_SERVICEFEEBOOKING_REPORTS_SUCCESS: {
      return {
        ...state,
        serviceFeeBookingReports: action.payload
      }
    }  
    default:
      return state;
  }
};
